exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.content[data-v-5ceef978] {\n  font-family: 'Roboto Mono', monospace;\n  font-size: 12px;\n  display: grid;\n  grid-template-columns: 3fr 2fr;\n  grid-gap: 16px;\n}\n.content .label[data-v-5ceef978] {\n  text-align: right;\n}\n.content .value[data-v-5ceef978] {\n  color: #42b983;\n}\n", ""]);

// exports
